import elevatedContainer from '../../../generic/elevatedContainer';
import $ from 'jquery';

/**
 * Creates carousels for car image and thumbnails
 */
class ImageCarousels {
  /**
   * @property {HTMLElement} fullScreenImageModal holds an elevated container;
   */
  #fullScreenImageModal;

  /**
   * Constructor
   * @param {HTMLElement} element - Element to bind to
   */
  constructor(element) {
    this.carImagesNav = element.querySelector('.car-image-carousel .slider-nav');
    this.carImagesMain = element.querySelector('.car-image-carousel .slider-main');
    this.currentSlide = document.querySelector('.slides-current');
    this.totalSlides = document.querySelector('.slides-total');
    this.#fullScreenImageModal = element.querySelector('.elevated-container');
    this.carImagesNav = element.querySelector('.car-image-carousel .slider-nav');
    this.carImagesMain = element.querySelector('.car-image-carousel .slider-main');

    element.querySelector('button#toggle-fullscreen-images-modal')?.addEventListener('click', this.#toggleFulscreenImagesModal.bind(this));

    $(this.carImagesMain).slick(this.getCarMainImageSettings());

    if (this.carImagesNav) {
      $(this.carImagesNav).slick(this.getCarImageSlickSettings());

      if (this.currentSlide) {
        this.currentSlide.textContent =
          $(this.carImagesNav).slick('getSlick').currentSlide + 1;
      }

      if (this.totalSlides) {
        this.totalSlides.textContent = $(this.carImagesNav).slick(
          'getSlick'
        ).slideCount;
      }

      this.currentSlide.textContent =
        $(this.carImagesNav).slick('getSlick').currentSlide + 1;
      this.totalSlides.textContent = $(this.carImagesNav).slick(
        'getSlick'
      ).slideCount;

      $(this.carImagesNav).on('afterChange', () => {
        this.currentSlide.textContent =
          $(this.carImagesNav).slick('getSlick').currentSlide + 1;
      });
    }

    // If slide has video, pause video when moving to prev/next slide and play video when slide is active
    $('.slider-main').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      const currentVideo = $(slick.$slides[currentSlide]).find('video');
      if (currentVideo.length) {
        currentVideo[0].pause();
      }
    });

    $('.slider-main').on('afterChange', function(event, slick, currentSlide) {
      const currentVideo = $(slick.$slides[currentSlide]).find('video');
      if (currentVideo.length) {
        currentVideo[0].play();
      }
    });
  }

  /**
   * Get settings for main carousel
   * @returns {Object}
   */
  getCarMainImageSettings() {
    return {
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      adaptiveHeight: false,
      arrows: true,
      prevArrow: $('.car-image-carousel .slick-prev'),
      nextArrow: $('.car-image-carousel .slick-next'),
      asNavFor: '.slider-nav',
      rows: 0
    };
  }

  /**
   * Get settings for thumbnail carousel
   * @returns {Object}
   */
  getCarImageSlickSettings() {
    const totalImagesInNavCarousel = 5;

    return {
      slidesToShow: totalImagesInNavCarousel,
      slidesToScroll: totalImagesInNavCarousel,
      variableWidth: false,
      adaptiveHeight: false,
      arrows: false,
      appendDots: $('.slick-dots-container'),
      dots: true,
      infinite: true,
      asNavFor: '.slider-main',
      centerMode: true,
      focusOnSelect: true,
      centerPadding: '40px',
      rows: 0,
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: totalImagesInNavCarousel,
            slidesToScroll: totalImagesInNavCarousel
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    };
  }

  #toggleFulscreenImagesModal() {
    elevatedContainer.toggleVisibility(this.#fullScreenImageModal);
    this.#fullScreenImageModal.querySelector('button[data-close]').focus();
  }

  /**
   * Initializes car image carousels
   */
  static init() {
    const imageCarousels = document.querySelectorAll('.car-image-carousel');

    if (imageCarousels.length) {
      Array.from(imageCarousels).forEach(imageCarousel => {
        new ImageCarousels(imageCarousel);
      });
    }
  }
}

export default ImageCarousels;
